<template>
  <div class="d-flex flex-column overflow-hidden h-100">
    <vue-custom-scrollbar
      class="app-content-padding flex-grow-1 overflow-hidden h-100"
    >
      <ts-page-title
        :title="$t('evaluationExamination.pageTitle')"
        :breadcrumb="[
          { text: $t('home'), href: '/' },
          {
            text: $t('evaluationExamination.pageTitle'),
            href: '/admin/academic/evaluation-examinations',
          },
          {
            text: $t('create'),
            active: true,
          },
        ]"
      />
      <ts-loading-banner :loading="waiting">
        <div class="row">
          <div class="col-md-5">
            <candidate-templete
              v-model="model"
              :validation="errors"
              ref="candidate"
              @clearError="clearError"
            />
          </div>
          <div class="col-md-7">
            <evaluation-templete
              v-model="model"
              :validation="errors"
              class="tw-h-full"
            />
          </div>
        </div>
      </ts-loading-banner>
    </vue-custom-scrollbar>
    <div
      id="footer"
      class="app-footer m-0 tw-flex tw-justify-end tw-space-x-2 tw-sh"
      style="background-color: #e9ecef"
    >
      <ts-button
        @click.prevent="$router.push({ name: 'evaluation-examination' })"
        :disabled="waiting_new || waiting"
        class="btn-gray"
      >
        {{ $t("cancel") }}</ts-button
      >
      <ts-button
        color="primary"
        outline
        :waiting="waiting_new"
        :disabled="waiting_new || waiting"
        @click.prevent="onSaveAddNew"
      >
        {{ $t("saveAddNew") }}</ts-button
      >
      <ts-button
        color="primary"
        :waiting="waiting"
        :disabled="waiting_new || waiting"
        @click.prevent="onSave"
      >
        {{ $t("save") }}</ts-button
      >
    </div>
  </div>
</template>

<script>
import AppOptions from "@/config/AppOptions.vue";
import CandidateTemplete from "./components/candidate.vue";
import EvaluationTemplete from "./components/evaluation.vue";
import { mapActions, mapState } from "vuex";
import { Errors } from "form-backend-validation";
import moment from "moment";

export default {
  name: "evaluationExaminationCreate",
  components: {
    CandidateTemplete,
    EvaluationTemplete,
  },
  data() {
    return {
      loading: false,
      waiting: false,
      waiting_new: false,
      errors: new Errors(),
      model: {
        issue_date: moment().format("DD-MM-YYYY"),
        candidate: [],
        evaluation_list: [],
      },
    };
  },
  created() {
    AppOptions.appContentFullHeight = true;
    AppOptions.appContentClass = "p-0";
  },
  computed: {
    ...mapState("academic/evaluationExamination", ["formViewDatas"]),
  },
  methods: {
    ...mapActions("academic/evaluationExamination", ["getFormViewData"]),
    async fetchFormViewModel({ params, index }) {
      this.waiting = true;
      await this.getFormViewData({
        index: index,
        params: params,
      });
      this.waiting = false;
    },
    async onSaveAddNew() {
      this.errors = new Errors();
      this.waiting_new = true;
      this.$store
        .dispatch(
          "academic/evaluationExamination/store",
          Object.assign({}, this.model)
        )
        .then(async (response) => {
          this.$notify({
            type: "success",
            text: response.message,
          });
          this.clearInput();
          await this.$refs.candidate.removeCadidate();
          await this.$refs.candidate.setModelData();
        })
        .catch((error) => {
          this.errors = new Errors(error.errors);
          this.$notify({ type: "error", text: error.message });
        })
        .finally(() => {
          this.waiting_new = false;
        });
    },
    async onSave() {
      this.errors = new Errors();
      this.waiting = true;
      this.$store
        .dispatch(
          "academic/evaluationExamination/store",
          Object.assign({}, this.model)
        )
        .then(async (response) => {
          this.$notify({
            type: "success",
            text: response.message,
          });
          this.$router.push({ name: "evaluation-examination" });
        })
        .catch((error) => {
          this.errors = new Errors(error.errors);
          this.$notify({ type: "error", text: error.message });
        })
        .finally(() => {
          this.waiting = false;
        });
    },
    clearError() {
      this.errors = new Errors();
    },
    clearInput() {
      this.model.is_evaluated = false;
    },
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.fetchFormViewModel({ params: {}, index: undefined });
    });
  },
  beforeRouteLeave(to, from, next) {
    AppOptions.appContentFullHeight = false;
    AppOptions.appContentClass = "";
    next();
  },
};
</script>
